module.exports = __webpack_public_path__ + "static/media/check_green.c2ded291.svg";